import Reservation from './reservation'

export default {
  strict: true,
  namespaced: true,
  state: Object.assign(
    Reservation.state
  ),
  mutations: Object.assign(
    Reservation.mutations
  )
}



// WEBPACK FOOTER //
// ./src/store/rsvp-track/index.js